<template>
	<div>
		<v-tabs v-model="tab" background-color="transparent" grow>
			<v-tab
				v-tooltip.bottom="modoAyuda && $help.calidad.incidencias.incidencias"
				v-if="permisoVista('incidencias','r')"
				@click="incidenciasClick"
			>
				Incidencias
			</v-tab>
			<v-tab
				v-tooltip.bottom="modoAyuda && $help.calidad.incidencias.sinEspecificar"
				v-if="permisoVista('defectonodesglozados','r')"
				@click="sinDesgloseClick"
			>
				Incidencias Sin Especificar
			</v-tab>
			<v-tab @click="parosEnCurso">
				Incidencias en Cursos
			</v-tab>
			<!--<v-tab @click="parosAbiertosReporte()" v-if="nombreEmpresa == 'Nyx' || nombreEmpresa == 'Glm'">
				Paros en curso
			</v-tab>
			<v-tab @click="parosIncompletosReporte()" v-if="nombreEmpresa == 'Nyx' || nombreEmpresa == 'Glm'">
				Paros Sin Especificar
			</v-tab>-->

			<v-tabs-items v-model="tab" touchless>
				<v-tab-item
					v-if="permisoVista('incidencias','r')"
					eager
				>
					<Paros ref="incid" />
				</v-tab-item>
				<v-tab-item
					v-if="permisoVista('defectonodesglozados','r')"
					eager
				>
					<SinDesglosar ref="sindesg" />
				</v-tab-item>
				<v-tab-item
					v-if="permisoVista('defectonodesglozados','r')"
					eager
				>
					<ParosEnCurso ref="paroEnCurso" />
				</v-tab-item>
				<!--<v-tab-item eager>
					<ParosAbiertosReporte ref="ParosAbiertosReporte" />
				</v-tab-item>
				<v-tab-item eager>
					<ParosIncompletosReporte ref="ParosIncompletosReporte" />
				</v-tab-item>-->
			</v-tabs-items>
		</v-tabs>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Paros from './Paros/Paros.vue';
import SinDesglosar from './Paros/SinDesglosar.vue';
import ParosEnCurso from './Paros/ParosEnCurso.vue'

export default {
	components: {
		Paros,
		SinDesglosar,
		ParosEnCurso,
	},
	data: () => ({
		tab: 0,
	}),
	computed:{
		...mapState(["modoAyuda", "nombreEmpresa"])
	},
	methods: {
		// leerParametros(){
		// 	if (this.$route.query.idArea != undefined){
		// 		this.$refs.incid.filtroDetalleIncidencia(this.$route.query.idArea);
		// 		this.$router.push('/dashboard/calidad');
		// 	}
		// },
		initialize() {
			this.incidenciasClick();
			this.sinDesgloseClick();
		},
		incidenciasClick(){
			if(typeof this.$refs.incid === 'undefined') return;
			this.$refs.incid.initialize();
		},
		sinDesgloseClick(){
			if(typeof this.$refs.sindesg === 'undefined') return;
			this.$refs.sindesg.initialize();
		},
		parosEnCurso(){
			if(typeof this.$refs.paroEnCurso === 'undefined') return;
			this.$refs.paroEnCurso.initialize();
		},
	},
};
</script>